export function ContactSection() {
  return (
    <section id="contact" className="py-40 px-6 lg:px-12 overflow-hidden">
      <div className="max-w-4xl mx-auto space-y-32">
        {/* Header */}
        <div className="text-center space-y-8 animate-fade-in">
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-[0.1em] sm:tracking-[0.15em] md:tracking-[0.2em] text-secondary/80 break-words px-4">
            CONTACT
          </h2>
        </div>

        {/* Contact Info - Minimal with animations */}
        <div className="space-y-24 text-center">
          <div className="space-y-6 animate-slide-up" style={{ animationDelay: '0.2s', opacity: 0 }}>
            <p className="text-sm tracking-[0.4em] text-white/40 uppercase">
              Location
            </p>
            <p className="text-xl tracking-[0.2em] text-white/60">
              Tamar Valley, Tasmania
            </p>
            <p className="text-lg tracking-[0.2em] text-white/60">
              Visit us at the Exeter markets for membership inquiries and networking opportunities.
            </p>
          </div>

          <div className="space-y-6 animate-slide-up" style={{ animationDelay: '0.4s', opacity: 0 }}>
            <p className="text-sm tracking-[0.4em] text-white/40 uppercase">
              EMAIL
            </p>
            {/* <p className="text-xl tracking-[0.2em] text-secondary/60">
              +61 3 6383 1473
            </p> */}
            <p className="text-sm tracking-[0.05em] sm:tracking-[0.15em] md:tracking-[0.3em] text-white/60 break-words px-4">
              tamarvalleybusinessassociation@gmail.com
            </p>
          </div>
        </div>

        {/* CTA - Simple with animation */}
        <div className="text-center pt-16 animate-fade-in-delayed">
          <a
            href="/contact"
            className="inline-block text-2xl tracking-[0.3em] text-secondary/70 hover:text-secondary transition-all duration-700 uppercase group"
          >
            Get in Touch
            <span className="inline-block ml-3 group-hover:translate-x-2 transition-transform duration-700">→</span>
          </a>
          <div className="w-32 h-px bg-secondary/30 mx-auto mt-8 group-hover:w-48 transition-all duration-700" />
        </div>
      </div>
    </section>
  );
}
